import { blogSchema } from "./blogSchema";

export const blogListSchema = [blogSchema];
